/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface DashboardCoreAPI
	 * @classdesc API class that is used to manage a dashboard.
	 */
	class DashboardCoreAPI {

		/**
		 * @description Returns the feature with the specified feature name.
		 * @param {string} name - Unique name of the feature
		 * @return {object} Feature API object; undefined if not found
		 */
		getFeature() {}

		/**
		 * @description Destroys the dashboard.
		 */
		destroy() {}

	}

	return DashboardCoreAPI;
});
